export const BUTTON_SIZES = {
    ['large']: '4rem',
    ['middle']: '3.5rem',
    ['small']: '2.5rem',
  };